/**
 * LazyPlot — react-plotly.js behind a dynamic import + Suspense so the ~4.9 MB
 * Plotly bundle loads ON DEMAND (after the app shell paints) instead of being a
 * static dependency that blocks first paint. Drop-in for the raw import:
 *
 *   -  import Plot from 'react-plotly.js';
 *   +  import { LazyPlot as Plot } from '@/components/LazyPlot';
 *
 * `import('react-plotly.js')` is the only runtime edge to Plotly across the app,
 * so rollup keeps it in its own async chunk. `import type { PlotParams }` is
 * erased at build time and does NOT pull the module eagerly. Once fetched,
 * Plotly is cached, so the fallback shows only on the very first chart mount.
 */
import { lazy, Suspense } from 'react';
import type { PlotParams } from 'react-plotly.js';

const Plot = lazy(() => import('react-plotly.js'));

export function LazyPlot(props: PlotParams) {
  return (
    <Suspense
      fallback={
        <div
          style={{
            height: '100%', minHeight: 160, width: '100%',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: '#333', fontSize: 12, letterSpacing: 2,
            fontFamily: 'Consolas, monospace',
          }}
        >
          LOADING CHART...
        </div>
      }
    >
      <Plot {...props} />
    </Suspense>
  );
}
